import React from 'react';
import { connect } from 'react-redux';
import './faqs.scss';
import { queryStringToJSON } from 'hb-redux-store/util/miscellaneousServices';
import { getFaqs } from 'hb-redux-store/feature/accounts/accounts.action';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import { Link } from 'react-router-dom';
import Icon from '../../components/mweb/Icon/Icon';
import AnalyticsService from 'AnalyticsService';
import WhatsappHelp from '../../components/common/WhatsappHelp/WhatsappHelp';

class FAQs extends React.Component {
  constructor(props) {
    super(props);
    const qs = queryStringToJSON(props.location.search);
    const { header = true } = qs;
    this.header = header;
  }

  componentDidMount() {
    if (!this.props.faqs) {
      this.props.getFaqs();
    }
    // Clevertap Analytics
    const key = 'View Faq';
    const payload = {
      title: 'FAQ',
    };
    AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
  }

  render() {
    const { loading, faqs } = this.props;
    return (
      <div className="faqs">
        {this.header && (
          <SecondaryNav
            source="accounts"
            showCart={false}
            showSearch={false}
            title="FAQs"
            capitalize
          />
        )}
        {loading && <Loader />}
        {!loading && (
          <div>
            <div className="faqs--title">Select Any Relevant Topic</div>
            <div className="faqs--list">
              {faqs?.length > 0 &&
                faqs.map(faq => {
                  return (
                    <Link
                      to={`/help/faqs/${encodeURI(
                        faq.topicName.toLowerCase()
                      )}`}
                      className="faqs--card"
                      key={faq.topicName}
                    >
                      <div className="faqs--card--content">
                        <img
                          className="faqs--card--illustration"
                          src={faq.topicImageUrl}
                        />
                        <div className="faqs--card--name">
                          <div>{faq.topicName}</div>
                          <Icon
                            class="icon-common-black-arrow-right card-icon-right"
                            size={10}
                          />
                        </div>
                      </div>
                    </Link>
                  );
                })}
            </div>
            <WhatsappHelp />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ accountsReducer }) => ({
  faqs: accountsReducer.faqs,
  loading: accountsReducer.loading,
});

const mapDispatchToProps = { getFaqs };

export default connect(mapStateToProps, mapDispatchToProps)(FAQs);
